// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Sbkk","field":"styles_field__3YLJN","fieldCol":"styles_fieldCol__301pw","diffCol":"styles_diffCol__3lAUe","diff":"styles_diff__2qD1g"};